import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
Vue.use(Vuex)

const state = {
    userInfo: {},   //当前登陆用户的信息
    nim: {},        //云信
    applyList: [],  //用户申请
    sessionList: [],//会话用户列表
    friendList: [], //通讯录列表
    chatList: {},   //聊天列表 [包括离线消息，漫游聊天]
    msgs: {},       //聊天消息缓存
    newestData: {}, //最新数据
    sysMsgUnread: 0, //系统通知未读数
    sysMsgs: [], //系统消息列表
    addRouter:0
}

export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js